import { get } from 'lodash';
import { useEffect, useState } from 'react';
import GetRecords from 'src/lib/api/GetRecords';
import { ANTRAGBERECHTIGTE_TYP } from 'src/lib/constants/constant';
import { APIS } from '../lib/constants/apis';
import { UseFetchStatesType } from '../lib/types/types';
import { isOrgaAbteilungEinerHochschule, isTrue, removeDataKeys, removeNullDeep } from '../utils/helper';

function useFetchAntragberechtigte(orgaData: any): UseFetchStatesType {
	const [loading, setLoading] = useState<boolean>(false);
	const [data, setData] = useState<any[]>([]);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		// Fetch data
		const fetchData = async () => {
			try {
				const res = await GetRecords(APIS.Antragsberechtigte, [], { Allgemein_Typ: ANTRAGBERECHTIGTE_TYP.Forschungseinrichtung });
				const result: any[] = removeNullDeep(removeDataKeys(get(res, 'data', [])));
				setData(result);
			} catch (err: any) {
				setError(err.message);
			} finally {
				setLoading(false);
			}
		};

		const isOrgaAbteilung = isOrgaAbteilungEinerHochschule(orgaData);

		if (isTrue(isOrgaAbteilung)) {
			fetchData();
		}
	}, [orgaData]);

	return { loading, data, error };
}
export { useFetchAntragberechtigte };
